import { getDepartmentIcon, getDepartmentName } from "../../core/constants/departments";

/**
 * Renders a single department icon from the shared config.
 */
const DepartmentIcon = ({ department, name, ...iconProps }) => {
  const deptRef = department ?? name;
  return getDepartmentIcon(deptRef, iconProps);
};

export default DepartmentIcon;

export { getDepartmentName as getDepartmentDisplayName };
